/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";

import {
    TextField,
    Grid,
    Card,
    CardContent,
    CardActions,
} from "@material-ui/core";
import CreditCardIcon from "@material-ui/icons/CreditCard";

import CartRouteComponent from "../components/Nav/CartRouteComponent";
import {useMutation} from "@apollo/client";
import {CREATE_PAYMENT} from "../queries";
import {useThemeData} from "../context/ThemeDataContext";
import {useCartData} from "../context/CartProvider";
import GeneralButton from "../components/Buttons";
import GeneralText from "../components/Fonts";

function Checkout(props) {
    const {site_id, siteoptions} = useThemeData().themeData.site;
    const {photographerType} = useThemeData();
    const {font_family, primary_color_2} = useThemeData().themeData.site.theme;

    const total_price = useCartData().cart.cartData.shoppingcart.totaal;
    const pay_school = useCartData().cart.cartData.shoppingcart.pay_school;
    const [Payment, setPayment] = useState([]);
    const [paymentType, setPaymentType] = useState(undefined);
    const [paymentMethod, setPaymentMethod] = useState(undefined);
    const [paymentStep, setPaymentStep] = useState(undefined);
    const [options, setOptions] = useState(undefined);
    const [bankOptions, setBankOptions] = useState(undefined);
    // const [CustomerData, setCustomerData] = useState({
    //   klant_IBAN: "",
    //   klant_naam: "",
    // });
    // const [validation, setValidation] = useState({
    //   klant_IBAN: "notActive",
    //   klant_naam: "notActive",
    // });
    const [validated, setValidated] = useState(false);
    const session_id = localStorage.getItem("session_id");
    // const APP_URL = process.env.REACT_APP_BASE_URL;

    const [createPayment, {loading, error}] = useMutation(CREATE_PAYMENT, {
        onCompleted: (data) => {
            if (data !== undefined) {
                if (photographerType === "equestrianphotoservice") {
                    window.top.location.href = data.createPayment.checkoutUrl;
                } else {
                    if (paymentType === "cardgate") {
                        if (data.createPayment.payment_step !== null) {
                            setPaymentStep(data.createPayment.payment_step);
                            if (data.createPayment.options !== null) {
                                if (data.createPayment.payment_step === "one") {
                                    setOptions(data.createPayment.options);
                                } else if (data.createPayment.payment_step === "two") {
                                    setOptions('Ideal');
                                    setBankOptions(data.createPayment.options);
                                }
                            }
                        }
                        if (data.createPayment.checkoutUrl !== null) {
                            window.location.href = data.createPayment.checkoutUrl;
                        }
                    } else {
                        window.location.href = data.createPayment.checkoutUrl;
                    }
                }
            }
        },
    });

    //if query site_options -> option_type === "payment" count how many there are. Is there more than one option, let people choose, else ...
    useEffect(() => {
        if (Payment.length <= 0) {
            let paymentTypes = siteoptions.filter(
                (site) => site.option_type === "payment"
            );
            let selectedPaymentTypes = [];


            if(paymentTypes.find(
                    (f) => f.option_name === "pay_through_school"
                ) !== undefined && pay_school==='ja'){
                selectedPaymentTypes = paymentTypes.filter(
                    (f) =>
                        f.option_name === "pay_through_school"
                );
            }else {

                if (
                    paymentTypes.find(
                        (f) => f.option_name === "multisafepay_display_name"
                    ) !== undefined &&
                    paymentTypes.find((f) => f.option_name === "cardgate_display_name") !==
                    undefined
                ) {
                    selectedPaymentTypes = paymentTypes.filter(
                        (f) =>
                            f.option_name !== "multisafepay_mode" &&
                            f.option_name !== "multisafepay_api_key" &&
                            f.option_name !== "cardgate_site_id" &&
                            f.option_name !== "cardgate_mode" &&
                            f.option_name !== "cardgate_api_key" &&
                            f.option_name !== "afterpay_site_IBAN" &&
                            f.option_name !== "sisow_merchant_id"
                    );
                } else if (
                    paymentTypes.find(
                        (f) => f.option_name === "multisafepay_display_name"
                    ) !== undefined
                ) {
                    selectedPaymentTypes = paymentTypes.filter(
                        (f) =>
                            f.option_name !== "multisafepay_mode" &&
                            f.option_name !== "multisafepay_api_key" &&
                            f.option_name !== "afterpay_site_IBAN" &&
                            f.option_name !== "sisow_merchant_id"
                    );
                } else if (
                    paymentTypes.find((f) => f.option_name === "cardgate_display_name") !==
                    undefined
                ) {
                    selectedPaymentTypes = paymentTypes.filter(
                        (f) =>
                            f.option_name !== "cardgate_site_id" &&
                            f.option_name !== "cardgate_mode" &&
                            f.option_name !== "cardgate_api_key" &&
                            f.option_name !== "afterpay_site_IBAN" &&
                            f.option_name !== "sisow_merchant_id"
                    );
                } else {
                    selectedPaymentTypes = paymentTypes.filter(
                        (f) =>
                            f.option_name !== "multisafepay_mode" &&
                            f.option_name !== "cardgate_site_id" &&
                            f.option_name !== "cardgate_mode" &&
                            f.option_name !== "afterpay_site_IBAN" &&
                            f.option_name !== "sisow_merchant_id"
                    );
                }
            }
            if (siteoptions && selectedPaymentTypes.length > 0) {
                setPayment(selectedPaymentTypes);
            }
        }



    }, [setPayment, Payment, siteoptions, total_price,pay_school]);

    const handlePayment = (e) => {
        e.preventDefault();
        const {name, value} = e.target;
        if (name === "payment_methode") {
            if (value !== "iDEAL") {
                createPayment({
                    variables: {
                        session_id: session_id,
                        site_id: site_id,
                        payment_step: "pay",
                        payment_gateway: value,
                        order_id: localStorage.getItem("order_id"),
                        type: paymentType, //cardgate or multisafepay
                        returnUrl:
                            window.location.protocol +
                            "//" +
                            window.location.host +
                            "/succes",
                    },
                });
            } else {
                createPayment({
                    variables: {
                        session_id: session_id,
                        site_id: site_id,
                        payment_step: "issuers",
                        payment_gateway: value,
                        order_id: localStorage.getItem("order_id"),
                        type: paymentType, //cardgate or multisafepay
                        returnUrl:
                            window.location.protocol +
                            "//" +
                            window.location.host +
                            "/succes",
                    },
                });
            }
            setPaymentMethod(value);
        } else if (name === "payment_bank") {
            createPayment({
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    payment_step: value, // wat moet er hier komen?
                    payment_gateway: paymentMethod,
                    issuer: value,
                    order_id: localStorage.getItem("order_id"),
                    type: paymentType, //cardgate or multisafepay
                    returnUrl:
                        window.location.protocol + "//" + window.location.host + "/succes",
                },
            });
        }
    };

    useEffect(() => {
        let paymentOptions = '';
        if(Payment.length === 2){
            paymentOptions = Payment[1].option_name;
        }

        /* Als korting en prijs is minder of gelijk aan nul?? Kunnen we dit nog netter afvangen? */
        if (parseInt(total_price) <= 0) {
            // Hoe kom ik hier? Want als je korting hebt of het totaal is 0, dan moet ie dit automatisch oppakken toch?
            // En bij een andere payment method, state updaten, evt extra velden en daarna pas createPayment en redirects
            /*Hier moeten we wat mee dit valt te manupuleren*/

            createPayment({
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    payment_step: "",
                    order_id: localStorage.getItem("order_id"),
                    type: "freeofcharge",
                    returnUrl:
                        window.location.protocol + "//" + window.location.host + "/succes",
                },
            });
        } else if (Payment.length === 1 || (Payment.length === 2 && paymentOptions === 'pay_through_school')) {
            //default if there is one payment methode it will auto run mollie
            const paymentOptions = Payment[0].option_name;

            let paymentOption = "";
            switch (paymentOptions) {
                case "sisow_api_key":
                    paymentOption = "sisow";
                    break;
                case "cardgate_api_key":
                case "cardgate_display_name":
                    paymentOption = "cardgate";
                    break;
                case "multisafepay_api_key":
                case "multisafepay_display_name":
                    paymentOption = "multisafepay";
                    break;
                case "mollie_api_key":
                    paymentOption = "mollie";
                    break;
                case "afterpay":
                    paymentOption = "afterpay";
                    setPaymentType("afterpay");
                    break;
                case "pay_through_school":
                    paymentOption = "pay_through_school";
                    setPaymentType("pay_through_school");
                    break;
                default:
                    //mollie_api_key
                    paymentOption = "mollie";
                    break;
            }

            if (paymentOption === "afterpay") {
                return;
            }

            createPayment({
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    order_id: localStorage.getItem("order_id"),
                    type: paymentOption,
                    payment_step: "pay",
                    returnUrl: window.location.protocol + "//" + window.location.host,
                },
            });
        }
    }, [
        createPayment,
        session_id,
        site_id,
        Payment,
        total_price,
        photographerType,
        paymentType,
        paymentStep,
    ]);

    const PAYMENT_TYPES = {
        afterpay: ["afterpay", "afterpay_site_IBAN", "afterpay_site_naam"],
        sisow: ["sisow_api_key"],
        cardgate: ["cardgate_display_name", "cardgate_api_key"],
        multisafepay: ["multisafepay_display_name", "multisafepay_api_key"],
        mollie: ["mollie_api_key"]
    };

    const handleChange = (event) => {
        const {value, name} = event.target;
        if (name === "klant_IBAN" || name === "klant_naam") {
            if (value !== "") {
                // setCustomerData((prevState) => ({ ...prevState, [name]: value }));
                // setValidation((prevState) => ({ ...prevState, [name]: true }));
            }
        } else {
            for (const [key, values] of Object.entries(PAYMENT_TYPES)) {
                if (values.includes(value)) {
                    setPaymentType(key);
                    return;
                }
            }
            // Default:
            setPaymentType("mollie");
        }
    };

    const onSubmit = (e) => {
        const form = e.currentTarget;
        const commonPayload = {
            variables: {
                session_id: session_id,
                site_id: site_id,
                order_id: localStorage.getItem("order_id"),
                type: paymentType,
                returnUrl: window.location.protocol + "//" + window.location.host,
            }
        };

        if (paymentType && paymentType !== "afterpay") {
            commonPayload.variables.payment_step = 'pay';
            createPayment(commonPayload);
        } else if (paymentType === "afterpay") {
            if (form.checkValidity()) {
                commonPayload.variables.returnUrl += "/succes";
                commonPayload.variables.klant_rekeninghouder = '';
                commonPayload.variables.klant_rekeningnummer = '';
                createPayment(commonPayload);
            }
        }
        setValidated(true);
    };

    function getPaymentDisplayName(option) {
        const paymentNames = {
            "mollie_api_key": "Ideal",
            "afterpay": "Vooruit Betalen",
            "sisow_api_key": "Sisow",
            "multisafepay_api_key": "Multisafepay",
            "cardgate_api_key": "Cardgate",
            "multisafepay_display_name": option.option_value,
            "cardgate_display_name": option.option_value
        };

        return paymentNames[option.option_name] || option.option_name;
    }

    if (loading) return <p>{props.t("Loading...")}</p>;
    if (error) return <p>{props.t("Looks like we have a problem...")}</p>;
    if (!Payment) return null;

// Sort the Payment array to ensure "Ideal" appears first
    const sortedPaymentOptions = [...Payment].sort((a, b) => {
        if (a.option_name === "mollie_api_key") return -1;
        if (b.option_name === "mollie_api_key") return 1;
        return 0;
    });

    return Payment.length >= 1 ? (
      <div className="container">
          <GeneralText className="text-center" variant="h3" gutterBottom={true}>
              Checkout
          </GeneralText>
          <CartRouteComponent activeStep={"3"}/>
          <Card
            className="subtitle"
            style={{
                fontFamily: `${font_family}`,
                color: `${primary_color_2}`,
            }}
          >
              <form noValidate validated={validated} onSubmit={onSubmit}>
                  <CardContent>
                      {(paymentType === undefined || paymentStep !== 'two') ? (
                        <Grid container direction="row">
                            <Grid item lg={6} md={12} sm={12}>
                                <TextField
                                  id="payment_option"
                                  name="payment_option"
                                  type="select"
                                  select
                                  SelectProps={{
                                      native: true,
                                  }}
                                  value={
                                      Payment.find((p) => p.option_name === paymentType)
                                        ?.option_name
                                  }
                                  label={props.t("checkout:Payment option")}
                                  onChange={handleChange}
                                  InputLabelProps={{shrink: true}}
                                  className="mb-2"
                                  variant="outlined"
                                  fullWidth
                                >
                                    <option value="check">
                                        {props.t("checkout:Choose your payment option")}
                                    </option>

                                    {sortedPaymentOptions.length > 0 &&
                                      sortedPaymentOptions
                                        .filter(p => p.option_name !== "pay_through_school")
                                        .map(p => (
                                          <option key={p.option_id} value={p.option_name}>
                                              {getPaymentDisplayName(p)}
                                          </option>
                                        ))
                                    }
                                </TextField>
                            </Grid>
                        </Grid>
                      ) : null}

                      {(paymentType === "cardgate") &&
                      options !== undefined &&
                      options !== null &&
                      options.length > 0 ? (
                        <>
                            {paymentMethod !== undefined && (<Grid container direction="row">
                                  <Grid item lg={6} md={12} sm={12}>
                                      <TextField
                                        id="payment_bank"
                                        name="payment_bank"
                                        type="select"
                                        select
                                        SelectProps={{
                                            native: true,
                                        }}
                                        value={'check'}
                                        label={props.t(`checkout:Bank`)}
                                        onChange={(e) => handlePayment(e)}
                                        InputLabelProps={{shrink: true}}
                                        // helperText={props.t(`checkout:Bank`)}
                                        className="mb-2"
                                        variant="outlined"
                                        fullWidth
                                      >
                                          <option value={'check'}>
                                              {props.t("checkout:Choose your bank option")}
                                          </option>
                                          {bankOptions !== undefined && bankOptions !== null &&
                                            bankOptions.map((data, i) => {
                                                return (
                                                  <option key={data.id} value={data.id}
                                                          style={{textTransform: 'capitalize'}}>
                                                      {data.name}
                                                  </option>
                                                );
                                            })}
                                      </TextField>
                                  </Grid>
                              </Grid>
                            )}
                        </>
                      ) : null}
                  </CardContent>
                  <CardActions>
                      <GeneralButton
                        style={{
                            marginRight: "0px",
                        }}
                        className="btn btn-light"
                        type="submit"
                        endIcon={<CreditCardIcon color="inherit"/>}
                      >
                          {props.t("checkout:Proceed to pay")}
                      </GeneralButton>
                  </CardActions>
              </form>
          </Card>
      </div>
    ) : null;
}

export default withTranslation(["message", "checkout"])(Checkout);
